import api from "./Api";

class OrdemServicoReceberService {
  GetOrdemServicoReceber(payload) {
    return api.get("/v1/ordemServicoReceber/" + payload).then((response) => {
      return response.data;
    });
  }

  PostOrdemServicoReceber(payload) {
    return api.post("/v1/ordemServicoReceber/", payload).then((response) => {
      return response.data;
    });
  }

  PutOrdemServicoReceber(payload) {
    return api.put("/v1/ordemServicoReceber/", payload).then((response) => {
      return response.data;
    });
  }

  DeleteOrdemServicoReceber(payload) {
    return api.delete("/v1/ordemServicoReceber/" + payload).then((response) => {
      return response.data;
    });
  }

  GetOrdemServicoReceberOData(payload) {
    return api.get("/OData/OrdemServicoReceber" + payload).then((response) => {
      return response.data;
    });
  }
}

export default new OrdemServicoReceberService();
